module.exports = __webpack_public_path__ + "static/img/2.1a98626e.png";